/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CanceledOrderClientDto } from '../models/CanceledOrderClientDto';
import type { CanceledOrderOperatorDto } from '../models/CanceledOrderOperatorDto';
import type { GetAvailableOrdersResponseDriver } from '../models/GetAvailableOrdersResponseDriver';
import type { GetDriverCurrentOrdersAdminResponse } from '../models/GetDriverCurrentOrdersAdminResponse';
import type { GetEstimatedAvailableOrderResponseDriver } from '../models/GetEstimatedAvailableOrderResponseDriver';
import type { GetMonitorOrdersResponseAdmin } from '../models/GetMonitorOrdersResponseAdmin';
import type { GetOrderAdminNotesAdminResponse } from '../models/GetOrderAdminNotesAdminResponse';
import type { GetOrderDeductionPreviewAdminResponse } from '../models/GetOrderDeductionPreviewAdminResponse';
import type { GetOrderDeliveryLiveDataClientResponse } from '../models/GetOrderDeliveryLiveDataClientResponse';
import type { GetOrderDiscountAdminResponse } from '../models/GetOrderDiscountAdminResponse';
import type { GetOrderDiscountClientResponse } from '../models/GetOrderDiscountClientResponse';
import type { GetOrderExtraItemClientResponse } from '../models/GetOrderExtraItemClientResponse';
import type { GetOrderExtraItemsAdminResponse } from '../models/GetOrderExtraItemsAdminResponse';
import type { GetOrderExtraItemsDriverResponse } from '../models/GetOrderExtraItemsDriverResponse';
import type { GetOrderExtraItemsOperatorResponse } from '../models/GetOrderExtraItemsOperatorResponse';
import type { GetOrderInvoiceAdminResponse } from '../models/GetOrderInvoiceAdminResponse';
import type { GetOrderItemClientResponse } from '../models/GetOrderItemClientResponse';
import type { GetOrderItemsAdminResponse } from '../models/GetOrderItemsAdminResponse';
import type { GetOrderItemsDriverResponse } from '../models/GetOrderItemsDriverResponse';
import type { GetOrderItemsOperatorResponse } from '../models/GetOrderItemsOperatorResponse';
import type { GetOrdersAdminResponse } from '../models/GetOrdersAdminResponse';
import type { GetOrdersCountByStatusAdminResponse } from '../models/GetOrdersCountByStatusAdminResponse';
import type { GetOrdersOperatorResponse } from '../models/GetOrdersOperatorResponse';
import type { GetOrderStatusCanBeUpdatedToResponseAdmin } from '../models/GetOrderStatusCanBeUpdatedToResponseAdmin';
import type { GetOrderStatusLogsOperatorResponse } from '../models/GetOrderStatusLogsOperatorResponse';
import type { GetOrderSupportReasonsClientResponse } from '../models/GetOrderSupportReasonsClientResponse';
import type { GetStreamOrdersResponseAdmin } from '../models/GetStreamOrdersResponseAdmin';
import type { GetStreamOrdersV2ResponseAdmin } from '../models/GetStreamOrdersV2ResponseAdmin';
import type { ListOf1OfOrderStatusLogDto } from '../models/ListOf1OfOrderStatusLogDto';
import type { MealStatus } from '../models/MealStatus';
import type { OrderAdminDto } from '../models/OrderAdminDto';
import type { OrderAdminNoteAdminDto } from '../models/OrderAdminNoteAdminDto';
import type { OrderClientDto } from '../models/OrderClientDto';
import type { OrderClientStatus } from '../models/OrderClientStatus';
import type { OrderCompensationType } from '../models/OrderCompensationType';
import type { OrderDriverDto } from '../models/OrderDriverDto';
import type { OrderFulfillmentMethod } from '../models/OrderFulfillmentMethod';
import type { OrderOperatorDetailDtoOperator } from '../models/OrderOperatorDetailDtoOperator';
import type { OrderOperatorDto } from '../models/OrderOperatorDto';
import type { OrderStatus } from '../models/OrderStatus';
import type { PackageStatus } from '../models/PackageStatus';
import type { Pagination1OfOrderClientListedDto } from '../models/Pagination1OfOrderClientListedDto';
import type { Pagination1OfOrderCompensationListedAdminDto } from '../models/Pagination1OfOrderCompensationListedAdminDto';
import type { Pagination1OfOrderOperatorListedDto } from '../models/Pagination1OfOrderOperatorListedDto';
import type { PostAcquireOrderRequestAdmin } from '../models/PostAcquireOrderRequestAdmin';
import type { PostAssignOrderRequestAdmin } from '../models/PostAssignOrderRequestAdmin';
import type { PostBroadcastOrderRequestAdmin } from '../models/PostBroadcastOrderRequestAdmin';
import type { PostCancelOrderClientRequest } from '../models/PostCancelOrderClientRequest';
import type { PostCancelOrderPhiRequest } from '../models/PostCancelOrderPhiRequest';
import type { PostEstimatedOrderClientRequest } from '../models/PostEstimatedOrderClientRequest';
import type { PostEstimatedOrderClientResponse } from '../models/PostEstimatedOrderClientResponse';
import type { PostJetOrderEstimateOperatorRequest } from '../models/PostJetOrderEstimateOperatorRequest';
import type { PostJetOrderEstimateOperatorResponse } from '../models/PostJetOrderEstimateOperatorResponse';
import type { PostJetOrderLocationResolveOperatorRequest } from '../models/PostJetOrderLocationResolveOperatorRequest';
import type { PostJetOrderLocationResolveOperatorResponse } from '../models/PostJetOrderLocationResolveOperatorResponse';
import type { PostJetOrderOperatorRequest } from '../models/PostJetOrderOperatorRequest';
import type { PostOrderAcceptAdminRequest } from '../models/PostOrderAcceptAdminRequest';
import type { PostOrderAcceptOperatorRequest } from '../models/PostOrderAcceptOperatorRequest';
import type { PostOrderAdminNoteAdminRequest } from '../models/PostOrderAdminNoteAdminRequest';
import type { PostOrderClientRequest } from '../models/PostOrderClientRequest';
import type { PostOrderCompensationAdminRequest } from '../models/PostOrderCompensationAdminRequest';
import type { PostOrderDeductionAdminRequest } from '../models/PostOrderDeductionAdminRequest';
import type { PostOrderSupportIntentClientRequest } from '../models/PostOrderSupportIntentClientRequest';
import type { PostOrderSupportIntentClientResponse } from '../models/PostOrderSupportIntentClientResponse';
import type { PostOrderSupportIntentPreviewClientRequest } from '../models/PostOrderSupportIntentPreviewClientRequest';
import type { PutOrderAddressRequestSigma } from '../models/PutOrderAddressRequestSigma';
import type { PutOrderAdminNoteAdminRequest } from '../models/PutOrderAdminNoteAdminRequest';
import type { PutOrderedItemAvailabilityOperatorRequest } from '../models/PutOrderedItemAvailabilityOperatorRequest';
import type { PutOrderItemsSigmaRequest } from '../models/PutOrderItemsSigmaRequest';
import type { ShipmentDriverDto } from '../models/ShipmentDriverDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OrdersService {
    /**
     * @returns OrderOperatorDetailDtoOperator OK
     * @throws ApiError
     */
    public static getOrderOperator({
        id,
        branchId,
    }: {
        id: string,
        branchId: number,
    }): CancelablePromise<OrderOperatorDetailDtoOperator> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operator/v1/orders/{id}/branch/{branchId}',
            path: {
                'id': id,
                'branchId': branchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetOrderItemsOperatorResponse OK
     * @throws ApiError
     */
    public static getOrderItemsOperator({
        orderId,
        branchId,
    }: {
        orderId: string,
        branchId: number,
    }): CancelablePromise<GetOrderItemsOperatorResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operator/v1/orders/{orderId}/items/{branchId}',
            path: {
                'orderId': orderId,
                'branchId': branchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetOrderExtraItemsOperatorResponse OK
     * @throws ApiError
     */
    public static getOrderExtraItemsOperator({
        orderId,
        branchId,
    }: {
        orderId: string,
        branchId: number,
    }): CancelablePromise<GetOrderExtraItemsOperatorResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operator/v1/orders/{orderId}/extra-items/{branchId}',
            path: {
                'orderId': orderId,
                'branchId': branchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetOrderStatusLogsOperatorResponse OK
     * @throws ApiError
     */
    public static getOrderStatusLogsOperator({
        orderId,
    }: {
        orderId: string,
    }): CancelablePromise<GetOrderStatusLogsOperatorResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operator/v1/orders/{orderId}/status-logs',
            path: {
                'orderId': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns Pagination1OfOrderOperatorListedDto OK
     * @throws ApiError
     */
    public static getOrdersHistoryOperator({
        branchId,
        orderStatus,
        fromDate,
        toDate,
        fulfillmentMethod,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        branchId: number,
        orderStatus?: OrderStatus,
        fromDate?: string,
        toDate?: string,
        fulfillmentMethod?: OrderFulfillmentMethod,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfOrderOperatorListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operator/v1/orders/history/{branchId}',
            path: {
                'branchId': branchId,
            },
            query: {
                'orderStatus': orderStatus,
                'fromDate': fromDate,
                'toDate': toDate,
                'fulfillmentMethod': fulfillmentMethod,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetOrdersOperatorResponse OK
     * @throws ApiError
     */
    public static getOrdersMonitoringOperator({
        branchId,
        orderStatus,
        fromDate,
        toDate,
        fulfillmentMethod,
    }: {
        branchId: number,
        orderStatus?: OrderStatus,
        fromDate?: string,
        toDate?: string,
        fulfillmentMethod?: OrderFulfillmentMethod,
    }): CancelablePromise<GetOrdersOperatorResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operator/v1/orders/monitoring/{branchId}',
            path: {
                'branchId': branchId,
            },
            query: {
                'orderStatus': orderStatus,
                'fromDate': fromDate,
                'toDate': toDate,
                'fulfillmentMethod': fulfillmentMethod,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns OrderOperatorDto OK
     * @throws ApiError
     */
    public static acceptOrderOperator({
        id,
        branchId,
        requestBody,
    }: {
        id: string,
        branchId: number,
        requestBody?: PostOrderAcceptOperatorRequest,
    }): CancelablePromise<OrderOperatorDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/operator/v1/orders/{id}/accept/{branchId}',
            path: {
                'id': id,
                'branchId': branchId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns OrderOperatorDto OK
     * @throws ApiError
     */
    public static postOrderInDeliveringOperator({
        id,
        branchId,
    }: {
        id: string,
        branchId: number,
    }): CancelablePromise<OrderOperatorDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/operator/v1/orders/{id}/in-delivering/{branchId}',
            path: {
                'id': id,
                'branchId': branchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns OrderOperatorDto OK
     * @throws ApiError
     */
    public static postOrderDeliveredOperator({
        id,
        branchId,
    }: {
        id: string,
        branchId: number,
    }): CancelablePromise<OrderOperatorDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/operator/v1/orders/{id}/delivered/{branchId}',
            path: {
                'id': id,
                'branchId': branchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns PostJetOrderEstimateOperatorResponse OK
     * @throws ApiError
     */
    public static postJetOrderEstimateOperator({
        branchId,
        requestBody,
    }: {
        branchId: number,
        requestBody?: PostJetOrderEstimateOperatorRequest,
    }): CancelablePromise<PostJetOrderEstimateOperatorResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/operator/v1/orders/jet-order/estimate/{branchId}',
            path: {
                'branchId': branchId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns OrderOperatorDto OK
     * @throws ApiError
     */
    public static postJetOrderOperator({
        branchId,
        requestBody,
    }: {
        branchId: number,
        requestBody?: PostJetOrderOperatorRequest,
    }): CancelablePromise<OrderOperatorDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/operator/v1/orders/jet-order/{branchId}',
            path: {
                'branchId': branchId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns PostJetOrderLocationResolveOperatorResponse OK
     * @throws ApiError
     */
    public static resolveJetOrderLocationOperator({
        requestBody,
    }: {
        requestBody?: PostJetOrderLocationResolveOperatorRequest,
    }): CancelablePromise<PostJetOrderLocationResolveOperatorResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/operator/v1/orders/jet-order/location/resolve',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns CanceledOrderOperatorDto OK
     * @throws ApiError
     */
    public static cancelOrderOperator({
        id,
        branchId,
        requestBody,
    }: {
        id: string,
        branchId: number,
        requestBody?: PostCancelOrderPhiRequest,
    }): CancelablePromise<CanceledOrderOperatorDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/operator/v1/orders/{id}/cancel/{branchId}',
            path: {
                'id': id,
                'branchId': branchId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns OrderOperatorDto OK
     * @throws ApiError
     */
    public static postOrderReadyPickedUpOperator({
        id,
        branchId,
    }: {
        id: string,
        branchId: number,
    }): CancelablePromise<OrderOperatorDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/operator/v1/orders/{id}/prepared/{branchId}',
            path: {
                'id': id,
                'branchId': branchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static putOrderItemsOperator({
        id,
        branchId,
        requestBody,
    }: {
        id: string,
        branchId: number,
        requestBody?: PutOrderItemsSigmaRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/operator/v1/orders/{id}/items/{branchId}',
            path: {
                'id': id,
                'branchId': branchId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static updateOrderedItemAvailabilityOperator({
        id,
        branchId,
        requestBody,
    }: {
        id: string,
        branchId: number,
        requestBody?: PutOrderedItemAvailabilityOperatorRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/operator/v1/orders/{id}/availability/{branchId}',
            path: {
                'id': id,
                'branchId': branchId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns OrderDriverDto OK
     * @throws ApiError
     */
    public static getOrderDriver({
        id,
    }: {
        id: string,
    }): CancelablePromise<OrderDriverDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/orders/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetOrderItemsDriverResponse OK
     * @throws ApiError
     */
    public static getOrderItemsDriver({
        id,
    }: {
        id: string,
    }): CancelablePromise<GetOrderItemsDriverResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/orders/{id}/items',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetOrderExtraItemsDriverResponse OK
     * @throws ApiError
     */
    public static getOrderExtraItemsDriver({
        id,
    }: {
        id: string,
    }): CancelablePromise<GetOrderExtraItemsDriverResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/orders/{id}/extra-items',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetAvailableOrdersResponseDriver OK
     * @throws ApiError
     */
    public static getAvailableOrdersDriver(): CancelablePromise<GetAvailableOrdersResponseDriver> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/orders/available',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns ShipmentDriverDto OK
     * @throws ApiError
     */
    public static acquireOrderDriver({
        orderId,
    }: {
        orderId: string,
    }): CancelablePromise<ShipmentDriverDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/orders/acquire/{orderId}',
            path: {
                'orderId': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static declineOrderDriver({
        orderId,
    }: {
        orderId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/orders/decline/{orderId}',
            path: {
                'orderId': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetEstimatedAvailableOrderResponseDriver OK
     * @throws ApiError
     */
    public static getEstimatedAvailableOrderRouteDriver({
        orderId,
    }: {
        orderId: string,
    }): CancelablePromise<GetEstimatedAvailableOrderResponseDriver> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/orders/{orderId}/estimate-route',
            path: {
                'orderId': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns OrderClientDto OK
     * @throws ApiError
     */
    public static getOrderClient({
        id,
    }: {
        id: string,
    }): CancelablePromise<OrderClientDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/orders/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetOrderDiscountClientResponse OK
     * @throws ApiError
     */
    public static getOrderDiscountClient({
        id,
    }: {
        id: string,
    }): CancelablePromise<GetOrderDiscountClientResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/orders/{id}/discount',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetOrderItemClientResponse OK
     * @throws ApiError
     */
    public static getOrderItemsClient({
        orderId,
    }: {
        orderId: string,
    }): CancelablePromise<GetOrderItemClientResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/orders/{orderId}/items',
            path: {
                'orderId': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetOrderExtraItemClientResponse OK
     * @throws ApiError
     */
    public static getOrderExtraItemsClient({
        orderId,
    }: {
        orderId: string,
    }): CancelablePromise<GetOrderExtraItemClientResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/orders/{orderId}/extra-items',
            path: {
                'orderId': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetOrderDeliveryLiveDataClientResponse OK
     * @throws ApiError
     */
    public static getOrderDeliveryLiveDataClient({
        orderId,
    }: {
        orderId: string,
    }): CancelablePromise<GetOrderDeliveryLiveDataClientResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/orders/{orderId}/delivery-live-data',
            path: {
                'orderId': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns Pagination1OfOrderClientListedDto OK
     * @throws ApiError
     */
    public static getOrdersClient({
        orderStatuses,
        fromDate,
        toDate,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        orderStatuses?: Array<OrderClientStatus>,
        fromDate?: string,
        toDate?: string,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfOrderClientListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/orders',
            query: {
                'orderStatuses': orderStatuses,
                'fromDate': fromDate,
                'toDate': toDate,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns OrderClientDto OK
     * @throws ApiError
     */
    public static postOrderClient({
        requestBody,
    }: {
        requestBody?: PostOrderClientRequest,
    }): CancelablePromise<OrderClientDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/client/v1/orders',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetOrderSupportReasonsClientResponse OK
     * @throws ApiError
     */
    public static getOrderSupportReasonsClient({
        orderId,
    }: {
        orderId: string,
    }): CancelablePromise<GetOrderSupportReasonsClientResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/orders/{orderId}/support-reasons',
            path: {
                'orderId': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns PostOrderSupportIntentClientResponse OK
     * @throws ApiError
     */
    public static postOrderSupportIntentClient({
        orderId,
        requestBody,
    }: {
        orderId: string,
        requestBody?: PostOrderSupportIntentClientRequest,
    }): CancelablePromise<PostOrderSupportIntentClientResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/client/v1/orders/{orderId}/support-intents',
            path: {
                'orderId': orderId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns PostOrderSupportIntentClientResponse OK
     * @throws ApiError
     */
    public static postOrderSupportIntentPreviewClient({
        orderId,
        requestBody,
    }: {
        orderId: string,
        requestBody?: PostOrderSupportIntentPreviewClientRequest,
    }): CancelablePromise<PostOrderSupportIntentClientResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/client/v1/orders/{orderId}/support-intents/preview',
            path: {
                'orderId': orderId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns CanceledOrderClientDto OK
     * @throws ApiError
     */
    public static postCancelOrderClient({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PostCancelOrderClientRequest,
    }): CancelablePromise<CanceledOrderClientDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/client/v1/orders/{id}/cancel',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                410: `Gone`,
            },
        });
    }
    /**
     * @returns PostEstimatedOrderClientResponse Created
     * @throws ApiError
     */
    public static postEstimateOrderClient({
        xAppVersion,
        requestBody,
    }: {
        xAppVersion?: string,
        requestBody?: PostEstimatedOrderClientRequest,
    }): CancelablePromise<PostEstimatedOrderClientResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/client/v1/orders/estimate',
            headers: {
                'x-App-Version': xAppVersion,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewLiveOrders`
     * @returns GetStreamOrdersResponseAdmin OK
     * @throws ApiError
     */
    public static getStreamOrdersAdmin({
        regionIds,
        orderStatuses,
        fetchAll,
        trackingPanelUserId,
        fromDate,
        toDate,
        branchId,
        userId,
    }: {
        regionIds: Array<number>,
        orderStatuses: Array<OrderStatus>,
        fetchAll?: boolean,
        trackingPanelUserId?: string,
        fromDate?: string,
        toDate?: string,
        branchId?: number,
        userId?: string,
    }): CancelablePromise<GetStreamOrdersResponseAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/orders/stream',
            query: {
                'fetchAll': fetchAll,
                'regionIds': regionIds,
                'orderStatuses': orderStatuses,
                'trackingPanelUserId': trackingPanelUserId,
                'fromDate': fromDate,
                'toDate': toDate,
                'branchId': branchId,
                'userId': userId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewLiveOrders`
     * @returns GetStreamOrdersV2ResponseAdmin OK
     * @throws ApiError
     */
    public static getStreamOrdersV2Admin({
        cursor,
        limit,
        orderStatuses,
        regionIds,
        trackingPanelUserId,
        fromDate,
        toDate,
        branchId,
        userId,
        referenceCode,
    }: {
        cursor?: string,
        limit?: number,
        orderStatuses?: Array<OrderStatus>,
        regionIds?: Array<number>,
        trackingPanelUserId?: string,
        fromDate?: string,
        toDate?: string,
        branchId?: number,
        userId?: string,
        referenceCode?: string,
    }): CancelablePromise<GetStreamOrdersV2ResponseAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/orders/streamv2',
            query: {
                'cursor': cursor,
                'limit': limit,
                'orderStatuses': orderStatuses,
                'regionIds': regionIds,
                'trackingPanelUserId': trackingPanelUserId,
                'fromDate': fromDate,
                'toDate': toDate,
                'branchId': branchId,
                'userId': userId,
                'referenceCode': referenceCode,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewMonitoring`
     * @returns GetMonitorOrdersResponseAdmin OK
     * @throws ApiError
     */
    public static getMonitorOrdersAdmin({
        regionIds,
        channelIds,
        orderStatuses,
        fetchAll,
        fromDate,
        toDate,
    }: {
        regionIds: Array<number>,
        channelIds: Array<number>,
        orderStatuses: Array<OrderStatus>,
        fetchAll?: boolean,
        fromDate?: string,
        toDate?: string,
    }): CancelablePromise<GetMonitorOrdersResponseAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/orders/monitor',
            query: {
                'fetchAll': fetchAll,
                'regionIds': regionIds,
                'channelIds': channelIds,
                'orderStatuses': orderStatuses,
                'fromDate': fromDate,
                'toDate': toDate,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Returns the active orders currently assigned to one driver for the monitoring modal.
     * **Required Policy:** `ViewDriverCurrentOrders`
     * @returns GetDriverCurrentOrdersAdminResponse OK
     * @throws ApiError
     */
    public static getDriverCurrentOrdersAdmin({
        driverId,
        orderStatuses,
        mealStatuses,
        packageStatuses,
        referenceCode,
        customerSearch,
        branchId,
        regionId,
        fulfillmentMethods,
        channelId,
        limit,
    }: {
        driverId: number,
        orderStatuses?: Array<OrderStatus>,
        mealStatuses?: Array<MealStatus>,
        packageStatuses?: Array<PackageStatus>,
        referenceCode?: string,
        customerSearch?: string,
        branchId?: number,
        regionId?: number,
        fulfillmentMethods?: Array<OrderFulfillmentMethod>,
        channelId?: number,
        limit?: number,
    }): CancelablePromise<GetDriverCurrentOrdersAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/orders/drivers/{driverId}/current',
            path: {
                'driverId': driverId,
            },
            query: {
                'orderStatuses': orderStatuses,
                'mealStatuses': mealStatuses,
                'packageStatuses': packageStatuses,
                'referenceCode': referenceCode,
                'customerSearch': customerSearch,
                'branchId': branchId,
                'regionId': regionId,
                'fulfillmentMethods': fulfillmentMethods,
                'channelId': channelId,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewOrderDetails`
     * @returns OrderAdminDto OK
     * @throws ApiError
     */
    public static getOrderAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<OrderAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/orders/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewOrderDetails`
     * @returns GetOrderDiscountAdminResponse OK
     * @throws ApiError
     */
    public static getOrderDiscountAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<GetOrderDiscountAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/orders/{id}/discount',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewOrderAdminNotes`
     * @returns GetOrderAdminNotesAdminResponse OK
     * @throws ApiError
     */
    public static getOrderAdminNoteAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<GetOrderAdminNotesAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/orders/{id}/admin-notes',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewOrderDetails`
     * @returns GetOrderInvoiceAdminResponse OK
     * @throws ApiError
     */
    public static getOrderInvoiceAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<GetOrderInvoiceAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/orders/{id}/invoice',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewOrderDetails`
     * @returns GetOrderItemsAdminResponse OK
     * @throws ApiError
     */
    public static getOrderItemsAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<GetOrderItemsAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/orders/{id}/items',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policies (One of):** `UpdateOrderItemsWhenItIsActive`, `UpdateOrderItemsWhenIsNotActive`
     * @returns any OK
     * @throws ApiError
     */
    public static putOrderItemsAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PutOrderItemsSigmaRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/orders/{id}/items',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewOrderDetails`
     * @returns GetOrderExtraItemsAdminResponse OK
     * @throws ApiError
     */
    public static getOrderExtraItemsAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<GetOrderExtraItemsAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/orders/{id}/extra-items',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewOrders`
     * @returns GetOrdersAdminResponse OK
     * @throws ApiError
     */
    public static getOrdersAdmin({
        id,
        orderStatus,
        userId,
        itemId,
        fulfillmentMethod,
        minSubTotalPrice,
        maxSubTotalPrice,
        branchId,
        regionIds,
        channelId,
        brandId,
        referenceCode,
        fromDate,
        toDate,
        cursor,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        id?: string,
        orderStatus?: OrderStatus,
        userId?: string,
        itemId?: number,
        fulfillmentMethod?: OrderFulfillmentMethod,
        minSubTotalPrice?: number,
        maxSubTotalPrice?: number,
        branchId?: number,
        regionIds?: Array<number>,
        channelId?: number,
        brandId?: number,
        referenceCode?: string,
        fromDate?: string,
        toDate?: string,
        cursor?: string,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<GetOrdersAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/orders',
            query: {
                'id': id,
                'orderStatus': orderStatus,
                'userId': userId,
                'itemId': itemId,
                'fulfillmentMethod': fulfillmentMethod,
                'minSubTotalPrice': minSubTotalPrice,
                'maxSubTotalPrice': maxSubTotalPrice,
                'branchId': branchId,
                'regionIds': regionIds,
                'channelId': channelId,
                'brandId': brandId,
                'referenceCode': referenceCode,
                'fromDate': fromDate,
                'toDate': toDate,
                'cursor': cursor,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewOrderDetails`
     * @returns ListOf1OfOrderStatusLogDto OK
     * @throws ApiError
     */
    public static getOrderStatusLogsAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<ListOf1OfOrderStatusLogDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/orders/{id}/status-logs',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewOrderDetails`
     * @returns GetOrderStatusCanBeUpdatedToResponseAdmin OK
     * @throws ApiError
     */
    public static getOrderStatusCanBeUpdatedToAdmin({
        orderStatus,
    }: {
        orderStatus?: OrderStatus,
    }): CancelablePromise<GetOrderStatusCanBeUpdatedToResponseAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/orders/status-can-be-updated-to',
            query: {
                'orderStatus': orderStatus,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Sets order deduction amount
     * This endpoint requires one of the following policies:
     * - UpdateOrderDeductionWhenItIsActive: For orders that are currently active
     * - UpdateOrderDeductionWhenIsNotActive: For orders that are not active
     *
     * A deduction never charges the customer's wallet. It refunds an online payment only while the order is
     * active (MO0024 afterwards), and on a completed order it changes the driver's cash only when
     * DriverCollectedAdjustedAmount is true (MO0025 otherwise). Call the preview endpoint first to show the effect.
     * @returns any OK
     * @throws ApiError
     */
    public static postOrderDeductionAdmin({
        id,
        requestBody,
    }: {
        /**
         * Order ID
         */
        id: string,
        /**
         * Deduction request details
         */
        requestBody?: PostOrderDeductionAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/orders/{id}/deduction',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Shows what posting the same body to the deduction endpoint would do, without saving anything: the new total,
     * the driver's cash before and after, any online refund to the customer, whether the operator must confirm what
     * the driver collected, and whether the change would be accepted.
     * **Required Policies (One of):** `UpdateOrderDeductionWhenItIsActive`, `UpdateOrderDeductionWhenIsNotActive`
     * @returns GetOrderDeductionPreviewAdminResponse OK
     * @throws ApiError
     */
    public static postOrderDeductionPreviewAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PostOrderDeductionAdminRequest,
    }): CancelablePromise<GetOrderDeductionPreviewAdminResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/orders/{id}/deduction/preview',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageOrderCompensation`
     * @returns any OK
     * @throws ApiError
     */
    public static postOrderCompensationAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PostOrderCompensationAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/orders/{id}/compensation',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policies (One of):** `ChangeOrderStatusWhenIsActive`, `ChangeOrderStatusWhenIsNotActive`
     * @returns any OK
     * @throws ApiError
     */
    public static postCancelOrderAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PostCancelOrderPhiRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/orders/{id}/admin-cancel',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policies (One of):** `ChangeOrderStatusWhenIsActive`, `ChangeOrderStatusWhenIsNotActive`
     * @returns any OK
     * @throws ApiError
     */
    public static postOrderNotDeliveredAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/orders/{id}/not-delivered',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policies (One of):** `ChangeOrderStatusWhenIsActive`, `ChangeOrderStatusWhenIsNotActive`
     * @returns any OK
     * @throws ApiError
     */
    public static postCancelOrderOperatorAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PostCancelOrderPhiRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/orders/{id}/operator-cancel',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ChangeOrderStatusWhenIsActive`
     * @returns any OK
     * @throws ApiError
     */
    public static postOrderApproveAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/orders/{id}/approve',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageOrderAdminNotes`
     * @returns OrderAdminNoteAdminDto OK
     * @throws ApiError
     */
    public static postOrderAdminNoteAdmin({
        orderAdminNoteId,
        requestBody,
    }: {
        orderAdminNoteId: string,
        requestBody?: PostOrderAdminNoteAdminRequest,
    }): CancelablePromise<OrderAdminNoteAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/orders/{orderAdminNoteId}/admin-notes',
            path: {
                'orderAdminNoteId': orderAdminNoteId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ChangeOrderStatusWhenIsActive`
     * @returns any OK
     * @throws ApiError
     */
    public static postOrderAcceptAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PostOrderAcceptAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/orders/{id}/accept',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageOrderAdminNotes`
     * @returns OrderAdminNoteAdminDto OK
     * @throws ApiError
     */
    public static putOrderAdminNoteAdmin({
        orderAdminNoteId,
        requestBody,
    }: {
        orderAdminNoteId: string,
        requestBody?: PutOrderAdminNoteAdminRequest,
    }): CancelablePromise<OrderAdminNoteAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/orders/admin-notes/{orderAdminNoteId}',
            path: {
                'orderAdminNoteId': orderAdminNoteId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteOrderAdminNotes`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteOrderAdminNoteAdmin({
        orderAdminNoteId,
    }: {
        orderAdminNoteId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/orders/admin-notes/{orderAdminNoteId}',
            path: {
                'orderAdminNoteId': orderAdminNoteId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `WatchOrders`
     * @returns any OK
     * @throws ApiError
     */
    public static postOrderTrackingAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/orders/{id}/tracking',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `StartOrderSearch`
     * @returns any OK
     * @throws ApiError
     */
    public static postBroadcastDeliveryAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PostBroadcastOrderRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/orders/{id}/broadcast',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `AssignOrderToDriver`
     * @returns any OK
     * @throws ApiError
     */
    public static postOrderAssignAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PostAssignOrderRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/orders/{id}/assign',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `UnassignOrderFromDriver`
     * @returns any OK
     * @throws ApiError
     */
    public static postOrderUnassignAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/orders/{id}/unassign',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `AcquireOrderToDriver`
     * @returns any OK
     * @throws ApiError
     */
    public static postOrderAcquireAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PostAcquireOrderRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/orders/{id}/acquire',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ChangeOrderStatusWhenIsActive`
     * @returns any OK
     * @throws ApiError
     */
    public static postDriverReachedBranchAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/orders/{id}/driver-reached-branch',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ChangeOrderStatusWhenIsActive`
     * @returns any OK
     * @throws ApiError
     */
    public static postOrderPickupAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/orders/{id}/picked-up',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ChangeOrderStatusWhenIsActive`
     * @returns any OK
     * @throws ApiError
     */
    public static postOrderDeliveringAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/orders/{id}/delivering',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ChangeOrderStatusWhenIsActive`
     * @returns any OK
     * @throws ApiError
     */
    public static postReachDestinationAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/orders/{id}/reach-destination',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policies (One of):** `ChangeOrderStatusWhenIsActive`, `ChangeOrderStatusWhenIsNotActive`
     * @returns any OK
     * @throws ApiError
     */
    public static postOrderCompleteAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/orders/{id}/complete',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageOrders`
     * @returns any OK
     * @throws ApiError
     */
    public static putOrderAddressAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PutOrderAddressRequestSigma,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/orders/{id}/address-point',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageOrders`
     * @returns any OK
     * @throws ApiError
     */
    public static postInvoiceAdmin({
        orderId,
    }: {
        orderId?: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/orders/zoho-create-invoice',
            query: {
                'orderId': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageOrders`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteInvoiceAdmin({
        orderId,
    }: {
        orderId?: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/orders/zoho-delete-invoice',
            query: {
                'orderId': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageOrders`
     * @returns any OK
     * @throws ApiError
     */
    public static postPaymentAdmin({
        orderId,
    }: {
        orderId?: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/orders/zoho-create-payment',
            query: {
                'orderId': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageOrders`
     * @returns any OK
     * @throws ApiError
     */
    public static postOrderInvoiceFulfillmentPaymentAdmin({
        invoiceFulfillmentId,
    }: {
        invoiceFulfillmentId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/orders/invoice-fulfillment/{invoiceFulfillmentId}/zoho-payment',
            path: {
                'invoiceFulfillmentId': invoiceFulfillmentId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageOrders`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteOrderInvoiceFulfillmentPaymentAdmin({
        invoiceFulfillmentId,
    }: {
        invoiceFulfillmentId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/orders/invoice-fulfillment/{invoiceFulfillmentId}/zoho-payment',
            path: {
                'invoiceFulfillmentId': invoiceFulfillmentId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageOrders`
     * @returns any OK
     * @throws ApiError
     */
    public static deletePaymentAdmin({
        orderId,
    }: {
        orderId?: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/orders/zoho-delete-payment',
            query: {
                'orderId': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageOrders`
     * @returns any OK
     * @throws ApiError
     */
    public static postCreditApplyAdmin({
        orderId,
    }: {
        orderId?: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/orders/zoho-apply-credit',
            query: {
                'orderId': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewOrders`
     * @returns GetOrdersCountByStatusAdminResponse OK
     * @throws ApiError
     */
    public static getOrdersCountByStatusAdmin({
        statuses,
        regionIds,
        trackingPanelUserId,
        fromDate,
        toDate,
        branchId,
        userId,
    }: {
        statuses?: Array<OrderStatus>,
        regionIds?: Array<number>,
        trackingPanelUserId?: string,
        fromDate?: string,
        toDate?: string,
        branchId?: number,
        userId?: string,
    }): CancelablePromise<GetOrdersCountByStatusAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/orders/count-by-status',
            query: {
                'statuses': statuses,
                'regionIds': regionIds,
                'trackingPanelUserId': trackingPanelUserId,
                'fromDate': fromDate,
                'toDate': toDate,
                'branchId': branchId,
                'userId': userId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewOrders`
     * @returns Pagination1OfOrderCompensationListedAdminDto OK
     * @throws ApiError
     */
    public static getOrderCompensationsAdmin({
        id,
        type,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        id: string,
        type?: OrderCompensationType,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfOrderCompensationListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/orders/{id}/compensations',
            path: {
                'id': id,
            },
            query: {
                'type': type,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageOrders`
     * @returns any OK
     * @throws ApiError
     */
    public static postOrderInvoiceFulfillmentPayAdmin({
        fulfillmentId,
    }: {
        fulfillmentId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/orders/invoices/fulfillments/{fulfillmentId}/pay',
            path: {
                'fulfillmentId': fulfillmentId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewLiveOrders`
     * @returns GetStreamOrdersV2ResponseAdmin OK
     * @throws ApiError
     */
    public static getStreamOrdersV2Admin1({
        cursor,
        limit,
        orderStatuses,
        regionIds,
        trackingPanelUserId,
        fromDate,
        toDate,
        branchId,
        userId,
        referenceCode,
    }: {
        cursor?: string,
        limit?: number,
        orderStatuses?: Array<OrderStatus>,
        regionIds?: Array<number>,
        trackingPanelUserId?: string,
        fromDate?: string,
        toDate?: string,
        branchId?: number,
        userId?: string,
        referenceCode?: string,
    }): CancelablePromise<GetStreamOrdersV2ResponseAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v2/orders/stream',
            query: {
                'cursor': cursor,
                'limit': limit,
                'orderStatuses': orderStatuses,
                'regionIds': regionIds,
                'trackingPanelUserId': trackingPanelUserId,
                'fromDate': fromDate,
                'toDate': toDate,
                'branchId': branchId,
                'userId': userId,
                'referenceCode': referenceCode,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
